var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgDimensions = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    stroke: borderColor,
    strokeLinejoin: "round",
    d: "m19 26 31.154 17.385a3 3 0 0 1 1.538 2.62V78.16a.2.2 0 0 1-.3.173l-30.23-17.396a3 3 0 0 1-1.503-2.539L18.999 26Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    stroke: borderColor,
    strokeLinejoin: "round",
    d: "M81.427 60.946 51.993 78.329a.2.2 0 0 1-.302-.173V45.981a3 3 0 0 1 1.507-2.602L83.5 26l-.6 32.418a3 3 0 0 1-1.473 2.528Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinejoin: "round",
    d: "M83.008 24.9 52.183 7.28a1 1 0 0 0-.984-.004l-31.526 17.62a1 1 0 0 0 .006 1.748l31.039 17.063a2 2 0 0 0 1.943-.009l15.455-8.689 14.886-8.37a1 1 0 0 0 .006-1.739Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeDasharray: "2 2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m23.813 57.496 10.023 5.812"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinejoin: "round",
    d: "m70.313 33.815-5.214 2.98-32.03-19.367 5.215-2.98 32.029 19.367Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinejoin: "round",
    d: "m69.809 47.51-3.214 1.837a1 1 0 0 1-1.496-.868V36.794l5.214-2.98v12.828a1 1 0 0 1-.504.868Z"
  }), React.createElement("path", {
    fill: color,
    d: "M16.278 24.216h.854V59.51h-.854z"
  }), React.createElement("path", {
    fill: color,
    d: "M16.278 58.627h1.707v.882h-1.707zM16.278 24.216h1.707v.882h-1.707zM7 45.737l3.217-7.283h.881l3.227 7.283H13.24l-.758-1.777H8.824l-.748 1.777H7Zm3.647-6.095-1.444 3.45h2.92l-1.455-3.45h-.02ZM18.84 62.953l.427-.745L49.58 79.854l-.427.746z"
  }), React.createElement("path", {
    fill: color,
    d: "m48.395 80.159.854-1.491.758.441-.854 1.49zM18.84 62.953l.853-1.49.758.44-.853 1.491zM28.217 79.309v-7.283h1.066v6.363h3.575v.92h-4.64ZM53.851 80.54l-.431-.743 30.213-17.823.43.743z"
  }), React.createElement("path", {
    fill: color,
    d: "m83.309 63.163-.863-1.486.756-.445.862 1.486zM53.851 80.54l-.862-1.486.755-.445.862 1.486zM72.434 79.402c-.73 0-1.356-.152-1.875-.455a3.034 3.034 0 0 1-1.198-1.291c-.274-.565-.41-1.23-.41-1.994s.136-1.425.41-1.983c.28-.558.68-.988 1.198-1.291.52-.303 1.144-.455 1.875-.455.492 0 .95.08 1.373.238.43.151.789.372 1.075.66l-.368.858a3.05 3.05 0 0 0-.974-.61 2.877 2.877 0 0 0-1.075-.196c-.779 0-1.373.242-1.783.724-.41.482-.615 1.167-.615 2.055 0 .888.205 1.577.615 2.066.41.482 1.004.723 1.783.723.389 0 .748-.062 1.075-.186.335-.13.66-.337.974-.62l.368.858a2.973 2.973 0 0 1-1.075.661 3.888 3.888 0 0 1-1.373.238Z"
  }));
};
export default SvgDimensions;